export const LOAN_AMOUNT_MIN = 100;
export const LOAN_AMOUNT_MAX = 10000;
export const LOAN_AMOUNT_STEP = 100;
export const LOAN_TERM_MIN = 3;
export const LOAN_TERM_MAX = 60;
export const LOAN_TERM_STEP = 1;
export const LOAN_AMOUNT = 1000;
export const LOAN_TERM = 12;
